import { AppInputSwitcher } from "../../components/Layouts/AppInputSwitcher/AppInputSwitcher";
import { t } from "i18next";
import AppStandardButton from "../../components/UI/AppButtons";
import { AppStandardMultiSelectCheckBox } from "../../components/UI/AppMultipleSelection";
import React, { useEffect, useState } from "react";
import { AppRadioButton } from "../../components/UI/AppRadioButtons/AppRadioButtons";
import { BookingApi } from "../../API/Apis/BookingApi";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import BookingGetters from "../../store/onlineBooking/getters";
import i18n from "../../config/i18n";

function TermsAndConditions({
  updateSelectedPrivacyPolicy,
  selectedPrivacyPolicy,
  allPrivacyPolicy,
  requiredPolicy,
  onTermsAcceptedChange,
  termsError = "",
}) {
  const [showTermCondition, setShowTermCondition] = useState(false);
  const toogleForTermCondition = () => {
    setShowTermCondition(!showTermCondition);
  };
  const lang = i18n.language;
  const textResource = BookingGetters.getTextResourceDetailsBasedOnLang();
  const data = textResource?.[lang]?.flatMap((item) => item.data || []) || [];
  const termsConditionAcceptText = data.find(
    (item) => item.key === "TermsConditionAcceptText"
  );
  const termsConditionAcceptBody = termsConditionAcceptText?.body;
  const { t: translate } = useTranslation();
  const [termCondition, setTermCondition] = useState<string>("");
  const [termAccepted, setTermAccepted] = useState<boolean>(false);

  useEffect(() => {
    if (onTermsAcceptedChange) {
      onTermsAcceptedChange(termAccepted);
    }
  }, [termAccepted]);

  useEffect(() => {
    if (termsConditionAcceptBody) {
      setTermAccepted(true);
    }
  }, [termsConditionAcceptBody]);
  const appSettings = BookingGetters.getAppSettings();

  const hidePrivacyPolicyButton = appSettings?.hidePrivacyPolicyButton;
  const showSpecialReservationTerms = appSettings?.showSpecialReservationTerms;
  const isSmallScreen = window.innerWidth <= 768;
  const isTabletScreen = window.innerWidth > 768 && window.innerWidth < 1300;
  const isGretaBookingNewUi = appSettings?.isGretaBookingNewUi;
  useEffect(() => {
    BookingApi.getPrivacyAndTerms().then((e) => {
      setTermCondition(e?.data?.conditionText);
    });
  }, []);

  return (
    <div
      className={
        isGretaBookingNewUi
          ? "flex flex-col box-border p-9 border-y-2 w-full md:w-[100%]"
          : "flex flex-col bg-white box-border p-8"
      }
    >
      <div
        className={`flex mb-5 gap-6 ${
          isGretaBookingNewUi
            ? "flex-col md:flex-row md:flex-wrap"
            : `flex-row flex-wrap ${!isSmallScreen ? "gap-8" : ""}`
        }`}
      >
        <AppStandardButton
          onClick={() => {
            BookingApi.getPrivacyAndTerms().then((e) => {
              const url = e.data.termsConditionFile;
              if (url.includes("s3.amazonaws")) {
                fetch(url).then(async (e) => {
                  const fileBlob = await e.blob();
                  const linkObj = document.createElement("a");
                  linkObj.href = URL.createObjectURL(fileBlob);
                  linkObj.target = "_blank";
                  linkObj.click();
                  return fileBlob;
                });
              } else {
                const linkObj = document.createElement("a");
                linkObj.href = url;
                linkObj.target = "_blank";
                linkObj.click();
              }
            });
          }}
          variant="contained"
          color="primary"
          style={{
            borderRadius: `${appSettings?.buttonBorderRadius || 0}px`,
            width: isGretaBookingNewUi
              ? undefined
              : isTabletScreen
              ? "24rem"
              : undefined,
          }}
          className={
            isGretaBookingNewUi
              ? "h-12 w-full md:w-auto"
              : `h-12 mt-8 ${!isTabletScreen ? "w-55" : ""}`
          }
        >
          <span>{t("Download terms and conditions")} </span>
        </AppStandardButton>
        {!hidePrivacyPolicyButton && (
          <AppStandardButton
            onClick={() => {
              BookingApi.getPrivacyAndTerms().then((e) => {
                const url = e.data.privacyfileUrl;
                if (url.includes("s3.amazonaws")) {
                  fetch(url).then(async (e) => {
                    const fileBlob = await e.blob();
                    const linkObj = document.createElement("a");
                    linkObj.href = URL.createObjectURL(fileBlob);
                    linkObj.target = "_blank";
                    linkObj.click();
                    return fileBlob;
                  });
                } else {
                  const linkObj = document.createElement("a");
                  linkObj.href = url;
                  linkObj.target = "_blank";
                  linkObj.click();
                }
              });
            }}
            variant="contained"
            color="primary"
            style={{
              borderRadius: `${appSettings?.buttonBorderRadius || 0}px`,
              width: isGretaBookingNewUi
                ? undefined
                : isTabletScreen
                ? "24rem"
                : undefined,
            }}
            className={
              isGretaBookingNewUi
                ? "h-12 w-full md:w-auto"
                : `h-12 mt-8 ${!isTabletScreen ? "w-55" : ""}`
            }
          >
            <span>{t("Download the privacy policy")} </span>
          </AppStandardButton>
        )}
        {showSpecialReservationTerms && (
          <AppStandardButton
            onClick={() => {
              BookingApi.getPrivacyAndTerms().then((e) => {
                const url = e?.data?.specialReservationTermsFile;
                if (!url || url.trim() === "") {
                  console.log("No special reservation terms file found");
                  return;
                }
                if (url.includes("s3.amazonaws")) {
                  fetch(url).then(async (e) => {
                    const fileBlob = await e.blob();
                    const linkObj = document.createElement("a");
                    linkObj.href = URL.createObjectURL(fileBlob);
                    linkObj.target = "_blank";
                    linkObj.click();
                    return fileBlob;
                  });
                } else {
                  const linkObj = document.createElement("a");
                  linkObj.href = url;
                  linkObj.target = "_blank";
                  linkObj.click();
                }
              });
            }}
            variant="contained"
            color="primary"
            style={{
              borderRadius: `${appSettings?.buttonBorderRadius || 0}px`,
              width: isGretaBookingNewUi
                ? undefined
                : isTabletScreen
                ? "24rem"
                : undefined,
            }}
            className={
              isGretaBookingNewUi
                ? "h-12 w-full md:w-auto"
                : `h-12 mt-8 ${!isSmallScreen ? "whitespace-nowrap" : ""} ${
                    !isTabletScreen ? "w-100" : ""
                  }`
            }
          >
            <span>{t("DOWNLOAD THE SPECIAL RESERVATION TERMS")} </span>
          </AppStandardButton>
        )}
      </div>

      {termsConditionAcceptBody != "" && termsConditionAcceptBody != null ? (
        <div
          className={" text-black text-base mt-2"}
          dangerouslySetInnerHTML={{ __html: termsConditionAcceptBody }}
        />
      ) : (
        <>
          {/* Render the checkbox/radio */}
          {isGretaBookingNewUi ? (
            <div>
              <div className="flex items-center">
                <AppRadioButton
                  required={!termAccepted}
                  color="primary"
                  value={
                    termAccepted
                      ? "I have read and agree to the rental conditions"
                      : ""
                  }
                  onChange={() => setTermAccepted(!termAccepted)}
                  options={[
                    {
                      label: t("I accept the "),
                      value: "I have read and agree to the rental conditions",
                    },
                  ]}
                />
                <span
                  className="text-md font-bold cursor-pointer text-black -ml-2"
                  onClick={toogleForTermCondition}
                >
                  {t("Terms and Conditions")}
                </span>
              </div>
              {termsError && (
                <p className="text-red-500 text-sm mt-1">{termsError}</p>
              )}
            </div>
          ) : (
            <>
              <AppStandardMultiSelectCheckBox
                required={true}
                color={"primary"}
                value={
                  termAccepted
                    ? ["I have read and agree to the rental conditions"]
                    : []
                }
                onChange={(vals) => setTermAccepted(vals.length > 0)}
                options={[
                  {
                    label: (
                      <>
                        <div
                          style={{
                            margin: isSmallScreen ? "0px" : "undefined",
                          }}
                        >
                          <span>{t("I accept the ")}</span>
                          <span
                            style={{ color: "primary" }}
                            onClick={toogleForTermCondition}
                            className="text-[primary] text-md font-bold"
                          >
                            {t("Terms and Conditions")}
                          </span>
                        </div>
                      </>
                    ),
                    value: "I have read and agree to the rental conditions",
                  },
                ]}
              />
              {termsError && (
                <p className="text-red-500 text-sm mt-1">{termsError}</p>
              )}
            </>
          )}
          <p
            className={`text-black text-base  ${
              isSmallScreen ? "mt-0" : "mt-2"
            }`}
          >
            {t("By clicking you're agreeing to our terms and conditions")}
          </p>
        </>
      )}

      {showTermCondition && termCondition.length > 0 && (
        <div className="bg-white box-border p-6 rounded-md shadow-md">
          <div
            className=" text-[#707070] text-sm text-left whitespace-pre-line"
            dangerouslySetInnerHTML={{ __html: termCondition }}
          />
        </div>
      )}

      {appSettings?.showMyRentPolicies && allPrivacyPolicy && (
        <div className="bg-white box-border p-3 rounded-md shadow-md mt-6">
          <span className="text-[#707070] text-sm text-left whitespace-pre-line">
            {allPrivacyPolicy.map((e, index) => {
              const optionsWithAsterisk = e
                ?.map((item) => {
                  const value =
                    i18n.language == "it"
                      ? item.privacyPolicyLocalLang
                      : item.privacyPolicyEn || "";
                  if (
                    Array.isArray(requiredPolicy) &&
                    requiredPolicy.length > 0
                  ) {
                    return requiredPolicy.includes(value) ? `*${value}` : value;
                  }
                  return value;
                })
                .filter((value) => value !== "");
              (item) => !!item;
              const isRequired = e.map((item) => {
                const value =
                  i18n.language == "it"
                    ? item.privacyPolicyLocalLang
                    : item.privacyPolicyEn || "";
                return requiredPolicy.includes(value) ? true : false;
              });
              return (
                <div key={index} className="mb-4">
                  <span className="text-md text-black font-bold">
                    Privacy policy {index + 1}
                  </span>
                  <br />
                  <AppStandardMultiSelectCheckBox
                    required={isRequired}
                    color={"primary"}
                    value={selectedPrivacyPolicy[index]}
                    options={optionsWithAsterisk}
                    onChange={(value) => {
                      updateSelectedPrivacyPolicy(index, value);
                    }}
                  />
                </div>
              );
            })}
          </span>
        </div>
      )}
    </div>
  );
}
export default TermsAndConditions;
